import { isNullOrWhiteSpace } from '@util/Common';
import moment from 'moment';
export default class Formatter {
}
Formatter.formatDate = (date, format = 'YYYY/M/DD HH:mm') => {
    const dt = moment(date, 'YYYY/MM/DD HH:mm');
    if (dt.isValid()) {
        return dt.format(format);
    }
    return '';
};
Formatter.formatCharOmit = (text, max = 80) => {
    if (!text)
        return '';
    return max < text.length ? `${text.slice(0, max)}…` : text;
};
// 勤務期間の日付フォーマット
Formatter.formatCareerPeriod = (startedAt, endedAt) => {
    const fmt = 'YYYY年M月';
    const started = moment(startedAt, 'YYYY/MM');
    const ended = moment(endedAt, 'YYYY/MM');
    if (!endedAt) {
        // 在籍中
        return started.isValid() ? `${started.format(fmt)}～現在` : '';
    }
    else {
        // それ以外
        let result = null;
        if (started.isValid()) {
            result = started.format(fmt);
        }
        if (ended.isValid()) {
            result = result ? `${result}～${ended.format(fmt)}` : ended.format(fmt);
        }
        return result;
    }
};
Formatter.formatAmount = (amount) => {
    if (!amount) {
        return '0 円';
    }
    return `${amount.toLocaleString()}円`;
};
Formatter.formatJob = (jobGroupId, jobId, otherName, options) => {
    var _a, _b, _c;
    if (isNullOrWhiteSpace(jobGroupId) || isNullOrWhiteSpace(jobId)) {
        return `その他`;
    }
    else {
        const group = (_a = options === null || options === void 0 ? void 0 : options.find((value) => (value === null || value === void 0 ? void 0 : value.id) === jobGroupId)) !== null && _a !== void 0 ? _a : null;
        const job = (_c = (_b = group === null || group === void 0 ? void 0 : group.jobs) === null || _b === void 0 ? void 0 : _b.find((value) => (value === null || value === void 0 ? void 0 : value.id) === jobId)) !== null && _c !== void 0 ? _c : null;
        if (group && job)
            return `${group.name} > ${job.name}`;
    }
    return '';
};
